
import { dataFetcher } from 'core/services/requestHandler';   

const getEnquiries = async (data = {}, config = {}) => {
  return dataFetcher('enquiries/getEnquiries', data, {...config});
};

const getEnquiryDetails = async (data = {}, config = {}) => {
  return dataFetcher('enquiries/getEnquiryDetails', data, {...config});
};

const saveEnquiry = async (data = {}, config = {}) => {
  return dataFetcher('enquiries/saveEnquiry', data, {method: 'POST', ...config});
};

const deleteEnquiry = async (data = {}, config = {}) => {
  return dataFetcher('enquiries/deleteEnquiry', data, {...config});
};

export { getEnquiries, getEnquiryDetails, deleteEnquiry, saveEnquiry };
